import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';

class SuccessDialog extends Component {
  render() {
    const { t } = this.props;
    return(
      <div>
        <button
          className="hidden"
          data-target="#modalSuccess"
          data-toggle="modal"
          id="btnSuccess"
          type="button">
        </button>
        <div className="modal fade" id="modalSuccess" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <h4>{t('guest.password.heading_success')}</h4>
                <p>{t('guest.password.success')}</p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-default"
                  data-dismiss="modal"
                  type="button">
                  {t('guest.password.btn_success')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(SuccessDialog);



// WEBPACK FOOTER //
// ./src/guest/recoveryPassword/SuccessDialog.js